module.exports = __webpack_public_path__ + "static/media/pp.0296903f.jpeg";